const GuiTypes = {
  DropDown: 'dropdown',
  Radio: 'radio',
  Text: 'text',
  ReadOnly: 'readonly'
};

export default GuiTypes;
